/**
 * React Query key factory for community-related queries
 * Provides consistent cache keys for React Query
 */

export const communityKeys = {
  all: ["communities"],
  trending: (time, limit) => [...communityKeys.all, "trending", time, limit],
  myJoined: () => [...communityKeys.all, "joined"],
  feed: (filters) => [...communityKeys.all, "feed", filters],
  discovery: () => [...communityKeys.all, "discovery"],
  search: (query) => [...communityKeys.all, "search", query],
  byField: (field) => [...communityKeys.all, "by-field", field],
  byTopic: (topic) => [...communityKeys.all, "by-topic", topic],
};

/**
 * Discovery-specific query keys (Phase 3)
 */
export const discoveryKeys = {
  all: ["discovery"],
  homepage: () => [...discoveryKeys.all, "homepage"],
  popular: (sortBy, limit) => [...discoveryKeys.all, "popular", sortBy, limit],
  recommended: (limit) => [...discoveryKeys.all, "recommended", limit],
  search: (query, limit) => [...discoveryKeys.all, "search", query, limit],
  byField: (field, limit, page) => [
    ...discoveryKeys.all,
    "by-field",
    field,
    limit,
    page,
  ],
  byTopic: (topic, limit, page) => [
    ...discoveryKeys.all,
    "by-topic",
    topic,
    limit,
    page,
  ],
  topics: (limit) => [...discoveryKeys.all, "topics", limit],
  fields: () => [...discoveryKeys.all, "fields"],
};
